module.exports = {
  siteTitle: "Sangeetha Yemisetty Portfolio", // <title>
  manifestName: "Resume",
  manifestShortName: "Landing", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: "#663399",
  manifestThemeColor: "#663399",
  manifestDisplay: "standalone",
  manifestIcon: "src/assets/img/website-icon.png",
  firstName: "Sangeetha",
  lastName: "Yemisetty",
  // social
  socialLinks: [
    {
      icon: "fa-github",
      name: "Github",
      url: "https://github.com/sangeethayemisetty",
    },
    {
      icon: "fa-linkedin-in",
      name: "Linkedin",
      url: "https://www.linkedin.com/in/yemisettysangeetha/",
    },
    {
      icon: "fa-google",
      name: "Gmail",
      url: "mailto:yemisettysangeetha@gmail.com",
    },
  ],
  email: "yemisettysangeetha@gmail.com",
  phone: "7093489873",
  address: "Hyderabad, India",
};
